module.exports = __webpack_public_path__ + "static/media/iconArrowDown.560cf8de.svg";